import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ApiConfigService } from '../../services/api-config.service';
import { CountrySelectionService } from '../../services/country-selection.service';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {
  privacyPolicyContent: any;

  constructor(private http: HttpClient, private apiConfigService: ApiConfigService, private countrySelectionService: CountrySelectionService) {}

  ngOnInit(): void {
    this.countrySelectionService.selectedCountry$.pipe(
      switchMap(country => {
        const apiUrl = this.countrySelectionService.getApiUrl('privacy_policy', country);
        return this.http.get<any[]>(apiUrl);
      })
    ).subscribe(data => {
      this.privacyPolicyContent = data[0];
    });
  }
}
